import { useContext } from "react";
import { UserReportContext } from "../../../context/UserReportContext";

export default function UserTimeSpentReportTableHooks() {
  const UserReportCxt = useContext(UserReportContext);

  const convertTimeSpent = (time,libType) => {
    if (time === 0) return "-";
    if(libType ===1){
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;

      const parts = [];
      if (hours > 0) parts.push(hours + " hrs");
      if (minutes > 0) parts.push(minutes + " mins");
      if (seconds > 0) parts.push(seconds + " secs");
      return parts.join(" ");
    }else{
       return time > 60
      ? Math.floor(time / 60) + " hrs " + (Math.round(time % 60) !== 0 ? Math.round(time % 60) + " mins" : "")
      : time === 0
      ? "-"
      : time + " mins";
    }
  };  

  const generateDataForUserTimeSpentReportTable = (data) => {
    const result = [];

    data.forEach((item) => {
      let lp = result.find((lp) => lp.lpname === item.lpname);

      if (!lp) {
        lp = { lpname: item.lpname, modules: [] };
        result.push(lp);
      }

      let module = lp.modules.find((m) => m.mname === item.mname);

      if (!module) {
        module = { morderno: item.morderno, mname: item.mname, test: [] };
        lp.modules.push(module);
      }

      let testEntry = module.test.find((t) => t.id === item.id);
      if (testEntry) {
        testEntry.timespent += item.timespent;
      } else {
        module.test.push({
          id: item.id,
          day: item.day,
          name: item.name,
          libtype: item.libtype,
          orderno: item.orderno,
          itemtype: item.itemtype,
          timespent: item.timespent,
          publisheddate: item.publisheddate,
        });
      }
    });

    UserReportCxt.setUserTimeSpentTableData(result);
  };

  return { convertTimeSpent, generateDataForUserTimeSpentReportTable };
}
